import React, { useEffect, useState, useRef } from 'react';
import { get } from 'lodash';
import { useUrlDataContext } from '../lib/UrlDataContext';
import { IoImageOutline, IoHelp } from 'react-icons/io5';
import './Image.scss';
import { getSmartImage } from '../../../helpers/helpers';

export const Image = ({ imagePath }) => {
  const { urlData, currentIndex } = useUrlDataContext();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [src, setSrc] = useState('');
  const isMounted = useRef(true);
  const currentSrc = get(urlData[currentIndex], imagePath);

  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (currentSrc) {
      const nextSrc = currentIndex < urlData.length - 1 ? get(urlData[currentIndex + 1], imagePath) : null;

      setLoading(true);
      setError(false);
      setSrc(currentSrc);

      const img = new window.Image();
      img.onload = () => {
        if (isMounted.current) {
          setLoading(false);
        }
      };
      img.onerror = () => {
        if (isMounted.current) {
          setError(true);
        }
      };
      img.src = currentSrc;

      if (nextSrc) {
        const nextImg = new window.Image();
        nextImg.src = nextSrc;
      }
    }
  }, [currentIndex, urlData, imagePath, currentSrc]);

  if (!currentSrc) {
    return (
      <div className='url-data-image missing'>
        <IoImageOutline size={48} />
        <span>No image</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className='url-data-image error'>
        <IoHelp size={48} />
        <span>Image won't load</span>
      </div>
    );
  }

  if (loading) {
    return <div className='url-data-image loading'>Loading...</div>;
  }

  return (
    <div className='url-data-image loaded'>
      <img src={getSmartImage(src)} alt='' />
    </div>
  );
};
